import { Stack, Typography, Button } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { useNavigate } from 'react-router-dom';

interface NoCalendarProps {
  showButton?: boolean;
}

export default function NoCalendar({ showButton = true }: NoCalendarProps) {
  const navigate = useNavigate();

  return (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} p={3}>
      <CalendarMonthIcon color="disabled" />
      <Typography variant="body2" color="text.secondary">
        No calendar found
      </Typography>
      {showButton && (
        <Button variant="outlined" size="small" onClick={() => navigate('/settings/calendar')}>
          Set up your Calendar
        </Button>
      )}
    </Stack>
  );
}
